import http from '../../../../libs/http'

export default (payload = {
  name: '',
  state: true,
  value: 0
}) => http.post(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/taxes`, payload)
